import { DrawerModal } from '@fagmobler/ui';
import { ServerProduct } from '@/lib/janitsjar/Product';
import Divider from '@/cataloguePages/productPageWithVariants/components/Divider';
import { Fragment } from 'react';
import {
  useCurrentStore,
  useStockByDistance,
} from '@/cataloguePages/productPageWithVariants/helpers';
import { Store } from '@/cataloguePages/productPageWithVariants/components/StorePickerStore';

type StorePickerProps = {
  product: ServerProduct;
  openedModal: string | null;
  closeModal: () => void;
};

export const StorePickerModalKey = 'store_picker';

export default function StorePicker({
  product,
  openedModal,
  closeModal,
}: StorePickerProps) {
  const currentStore = useCurrentStore();
  const stockByDistance = useStockByDistance(product);

  const availableInStores = stockByDistance.filter(
    (store) => store.stock && store.stock.stock > 0
  ).length;

  return (
    <DrawerModal
      isOpen={openedModal === StorePickerModalKey}
      onClose={closeModal}
      title="Lagerstatus i butikk"
    >
      <div className="p-4 md:p-6 flex flex-col gap-2 items-start">
        <h1 className="hd-base">På lager i {availableInStores} butikker</h1>
        <Divider />
        {stockByDistance.map((store) => (
          <Fragment key={store.id}>
            <Store
              store={store}
              isCurrentStore={store.id === currentStore?.id}
            />
            <Divider />
          </Fragment>
        ))}
      </div>
    </DrawerModal>
  );
}
